import { Button } from "../ui/button";
import { Sparkles } from "lucide-react";

const PRIORITY_COLOR = {
  alta: "bg-red-100 text-red-700",
  "média": "bg-amber-100 text-amber-700",
};
const CATEGORY_BORDER = {
  cv: "border-l-sky-400",
  "competências": "border-l-emerald-400",
  candidatura: "border-l-amber-400",
};

/** Sugestões de melhoria do perfil geradas por IA. */
export const ProfileOptimizer = ({ optimizing, suggestions, onAnalyze }) => (
  <div className="bg-gradient-to-br from-sky-50 to-slate-50 border border-sky-100 rounded-2xl p-6">
    <div className="flex items-start justify-between gap-3 mb-3">
      <div>
        <p className="font-heading font-bold tracking-tighter text-slate-900 flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-sky-500" /> Otimizar perfil com IA
        </p>
        <p className="text-xs text-slate-500 mt-1">
          A IA analisa o teu CV e perfil e gera sugestões personalizadas baseadas nas vagas disponíveis na tua zona.
        </p>
      </div>
      <Button data-testid="optimize-profile-btn" size="sm"
        className="rounded-full bg-sky-600 hover:bg-sky-700 shrink-0"
        disabled={optimizing} onClick={onAnalyze}>
        {optimizing ? "A analisar..." : "Analisar perfil"}
      </Button>
    </div>

    {suggestions && (
      <div className="space-y-3 mt-4 pt-4 border-t border-sky-100">
        {suggestions.map((s) => (
          <div key={`${s.category}-${s.title}`}
            className={`bg-white rounded-xl p-4 border-l-4 ${CATEGORY_BORDER[s.category] || "border-l-purple-400"} border border-black/5`}>
            <div className="flex items-center gap-2 mb-1">
              <p className="font-semibold text-sm text-slate-900">{s.title}</p>
              <span className={`text-[10px] uppercase font-bold px-2 py-0.5 rounded-full ${PRIORITY_COLOR[s.priority] || "bg-slate-100 text-slate-600"}`}>
                {s.priority}
              </span>
            </div>
            <p className="text-xs text-slate-600 leading-relaxed">{s.detail}</p>
          </div>
        ))}
        <Button variant="ghost" size="sm" className="rounded-full text-sky-600 hover:text-sky-700"
          disabled={optimizing} onClick={onAnalyze}>
          <Sparkles className="w-3.5 h-3.5 mr-1.5" /> Gerar novas sugestões
        </Button>
      </div>
    )}
  </div>
);
